import { BmHttp } from "../utils/Global";


export const createCitaPaciente = async (cita) => {
    try {
        const { data } = await BmHttp().post('create_cita', cita)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ListarCitaClinica = async (idclinica) => {
    try {
        const { data } = await BmHttp().get(`get_citas?idclinica=${idclinica}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ActualizarCita = async (cita) => {
    try {
        const { data } = await BmHttp().post('up_cita', cita)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ActualizarEstadoCita = async (cita) => {
    try {
        const { data } = await BmHttp().post('up_estado_cita', cita)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const EliminarCita = async (idcita) => {
    try {
        const { data } = await BmHttp().delete('get_cita?idcita='+idcita)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerCitaPaciente = async (idpaciente, idcita) => {
    try {
        const { data } = await BmHttp().get(`get_citas_paciente?idpaciente=${idpaciente}&idcita=${idcita}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

// Signos vitales
export const ControllerListarUltimoSignosVitales = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`signosvitales_one/signosvitales_one?idcita=${idcita}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerUpadateCreateSignosVitales = async (signosvitales) => {
    try {
        const { data } = await BmHttp().post('signosvitales_create', signosvitales)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ControllerListarCitaId = async (idcita) => {
    try {
        const { data } = await BmHttp().get(`get_citas_id?idcita=${idcita}`)
        return data
    } catch (error) {
        console.log(error);
    }
}

export const ListarResultadosExamenes = async({ page = 1, limit = 10, filters }) => {
    try {
        const { fecha_inicial, fecha_final, paciente, busqueda, procedimiento, estado_id, seguro } = filters

        const { data } = await BmHttp().get(`resultados`, {params: {
            page, limit,
            fecha_inicial: fecha_inicial || undefined,
            fecha_final: fecha_final || undefined,
            paciente: paciente || undefined,
            busqueda: busqueda || undefined,
            procedimiento: procedimiento || undefined,
            estado_id: estado_id || undefined,
            // RESULTADOS-07: "particular" o el id numerico de un seguro.
            seguro: seguro || undefined,
        }});
        return data;
        
    } catch (error) {
        return error.response.data;
    }
}

export const PostResultadosExamenes = async(datos) => {
    try {

        const { data } = await BmHttp().post(`resultados`, datos);
        return data;
        
    } catch (error) {
        return error.response.data;
    }
}

export const PutResultadosExamenes = async( id, payload ) => {
    try {

        const { data } = await BmHttp().put(`resultados/${id}`, payload);
        return data;

    } catch (error) {
        return error.response.data;
    }
}

// RESULTADOS-05: CRUD de tipos de documento de resultados por compañia.
export const ListarTiposDocumentoResultado = async () => {
    try {
        const { data } = await BmHttp().get(`resultado-tipos-documento`);
        return data;
    } catch (error) {
        return error.response?.data ?? { success: false, data: [], message: "Error de red" };
    }
}

export const CrearTipoDocumentoResultado = async (tipo) => {
    try {
        const { data } = await BmHttp().post(`resultado-tipos-documento`, { tipo });
        return data;
    } catch (error) {
        return error.response?.data ?? { success: false, message: "Error de red" };
    }
}

export const ActualizarTipoDocumentoResultado = async (id, tipo) => {
    try {
        const { data } = await BmHttp().put(`resultado-tipos-documento/${id}`, { tipo });
        return data;
    } catch (error) {
        return error.response?.data ?? { success: false, message: "Error de red" };
    }
}

export const EliminarTipoDocumentoResultado = async (id) => {
    try {
        const { data } = await BmHttp().delete(`resultado-tipos-documento/${id}`);
        return data;
    } catch (error) {
        return error.response?.data ?? { success: false, message: "Error de red" };
    }
}

